module.exports = __webpack_public_path__ + "media/images/amenities_icons/free_beer-22c5790559ad65ef2a4285b1acb8806f.svg";